import higherOrderSaga from 'Stores/hos';
import UserServiceV1 from 'Services/v1/user';
import { profileSliceActions } from 'Stores/profile/index';

const profileSaga = higherOrderSaga.createFetchedSaga(profileSliceActions, UserServiceV1.getProfile.bind(UserServiceV1));

export default profileSaga;